import { createFileRoute } from '@tanstack/react-router'
// TODO: Put a rolodex-fetcher in the Tanstack context so it can be used in a beforeLoad
// eslint-disable-next-line boundaries/dependencies
import { useRolodexEntries } from 'features/rolodex'
import { RolodexEntryType } from 'gecko-types'
import { useEffect, useMemo } from 'react'
import { Route as LifecycleRoute } from 'routes/assets/(single_asset_destinations)/lifecycle'
import { Route as BaseUnitPageRoute } from 'routes/assets/(single_asset_destinations)/unit'
import { assetRoutingSearchParams } from 'routes/assets/-searchParams'

export function RouteComponent() {
  const { useSearch, useNavigate } = Route

  const { siteId } = useSearch()

  const { siteConfigs, isLoading, hasEverLoaded } = useRolodexEntries(
    useMemo(
      () => ({
        type: RolodexEntryType.SITE_CONFIG,
        tags: { site: siteId },
        limit: 1,
      }),
      [siteId]
    )
  )

  const navigate = useNavigate()
  const destination = siteConfigs.at(0)?.data.useAssetLifecycle
    ? LifecycleRoute.to
    : BaseUnitPageRoute.to

  useEffect(() => {
    if (isLoading || !hasEverLoaded) return

    void navigate({
      to: destination,
      search: (prev) => prev,
      replace: true,
    })
  }, [destination, hasEverLoaded, isLoading, navigate])

  return null
}

export const Route = createFileRoute('/assets/routing')({
  validateSearch: assetRoutingSearchParams,
  component: RouteComponent,
})
